export function changeUTMparamsForTracking() {
  const urlVisited = window.location.href
  const UTM_PARAMS = {
    utmMedium: 'utm_medium',
    utmCampaign: 'utm_campaign'
  }
  const { utmCampaign, utmMedium } = UTM_PARAMS
  if (urlVisited.includes(utmCampaign) && !urlVisited.includes(utmMedium)) {
    const getUTMParams = window.location.search.split('&')
    const [getUTMCampaign] = getUTMParams.filter((item) =>
      item.includes(utmCampaign)
    )
    const utmCampaignValue = getUTMCampaign.split('=').at(1)

    history.pushState(
      null,
      null,
      `${window.location.search}&${utmMedium}=${utmCampaignValue}`
    )
  }
}
